import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      return;
    }
    setFormStatus('submitting');
    setFormError('');
    try {
      const response = await fetch('https://readdy.ai/api/form/d9qshuue3oq4jqumtq4g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: unknown;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      const parsedObj = parsed as Record<string, unknown> | null;
      const code = parsedObj?.code;
      const serverMsg = String(parsedObj?.meta?.message ?? parsedObj?.message ?? parsedObj?.meta?.detail ?? responseText);
      if (response.ok && code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
        setFormError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查网络后重试');
    }
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="关于我们 - 黑料网不打烊"
        description="黑料网不打烊品牌介绍，了解我们的使命与价值观。24小时娱乐八卦资讯平台，致力于为用户提供最新最全的黑料内容。"
        keywords="关于黑料网不打烊,黑料网品牌介绍,娱乐八卦平台,联系我们"
        canonicalUrl="https://heiliao-budayang.com/about"
        ogTitle="关于我们 - 黑料网不打烊"
        ogDescription="了解黑料网不打烊的品牌故事与使命。"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于黑料网不打烊',
            description: '了解黑料网不打烊的品牌故事、使命与价值观。',
            url: 'https://heiliao-budayang.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '黑料网不打烊',
              url: 'https://heiliao-budayang.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '黑料网不打烊是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '黑料网不打烊是一个24小时不间断更新的娱乐八卦资讯聚合平台，汇聚娱乐圈、网红圈、明星圈最新劲爆黑料内容，为用户提供全面、及时、独家的黑料资讯。',
                },
              },
              {
                '@type': 'Question',
                name: '黑料网不打烊的内容多久更新一次？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '黑料网不打烊全天候24小时不间断更新，确保用户随时随地都能获取最新的独家黑料内容。我们的编辑团队7×24小时轮班工作，保证内容的时效性和准确性。',
                },
              },
              {
                '@type': 'Question',
                name: '如何向黑料网不打烊投稿？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过我们的投稿邮箱 tips@heiliao-budayang.com 提交线索或稿件。我们欢迎各界人士提供真实可靠的爆料信息，所有投稿都会经过编辑团队的严格审核。',
                },
              },
              {
                '@type': 'Question',
                name: '黑料网不打烊的内容是否可靠？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们致力于为读者提供真实、可靠的娱乐资讯。所有发布的内容都经过编辑团队的多方核实和严格把关。但由于娱乐资讯的特殊性，部分内容可能涉及未经官方确认的消息，我们会在文章中明确标注信息来源。',
                },
              },
            ],
          }),
        }}
      />

      <Navbar />

      <main className="pt-16">
        <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]} />

            <div className="text-center mb-14">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-fire-line text-4xl"></i>
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading mb-4">关于我们</h1>
              <p className="text-foreground-500 text-base max-w-2xl mx-auto leading-relaxed">
                黑料网不打烊，致力于打造全网最全面的娱乐八卦资讯平台，24小时不打烊，为您带来最新最热的独家内容。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              <div className="text-center p-6 rounded-lg bg-background-100 border border-background-200/60">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-timer-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">24小时更新</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">全天候不间断更新最新独家黑料内容，从不停歇，永不打烊</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-100 border border-background-200/60">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">独家内容</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">汇聚娱乐圈、网红、明星最劲爆料，独家深度报道</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-100 border border-background-200/60">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-user-heart-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">用户至上</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">百万用户信赖，提供随时随地畅享海量黑料资讯的体验</p>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-2xl font-bold text-foreground-900 font-heading mb-6">
                <a href="#brand-story">品牌故事</a>
              </h2>
              <div className="prose prose-base max-w-none text-foreground-700 leading-relaxed">
                <p>
                  黑料网不打烊成立于2024年，由一群热爱娱乐八卦文化的资深媒体人共同创立。我们深知，在这个信息爆炸的时代，读者需要的不仅仅是零散的资讯，更是一个值得信赖的、全面的娱乐资讯平台。
                </p>
                <p>
                  我们的团队由资深娱记、专业编辑和技术精英组成，秉承"真实、快速、独家"的理念，7×24小时不间断运营。从娱乐圈的内幕消息到网红圈的精彩爆料，从明星八卦到综艺争议，我们力求覆盖每一个读者关心的领域。
                </p>
                <p>
                  短短两年时间，黑料网不打烊已经积累了超过500万的忠实读者，月均浏览量突破3亿次。我们的内容被广泛转载和引用，已成为华语娱乐资讯领域不可忽视的重要力量。
                </p>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-2xl font-bold text-foreground-900 font-heading mb-6">
                <a href="#reputation">口碑与荣誉</a>
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span key={star} className="w-5 h-5 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 mb-2 leading-relaxed">"每天必刷的八卦网站，内容更新又快又全，编辑们的文笔也很不错！"</p>
                  <span className="text-xs text-foreground-400">—— 资深读者 王先生</span>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span key={star} className="w-5 h-5 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 mb-2 leading-relaxed">"作为圈内人，黑料网不打烊的信息准确度真的很高，很多独家爆料都是首发。"</p>
                  <span className="text-xs text-foreground-400">—— 媒体从业者 李女士</span>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span key={star} className="w-5 h-5 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 mb-2 leading-relaxed">"页面设计简洁好看，没有乱七八糟的广告，阅读体验很棒。"</p>
                  <span className="text-xs text-foreground-400">—— 忠实粉丝 张同学</span>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span key={star} className="w-5 h-5 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 mb-2 leading-relaxed">"熬夜党福音！凌晨三点还能看到最新的八卦更新，真·不打烊！"</p>
                  <span className="text-xs text-foreground-400">—— 夜猫子读者 陈小姐</span>
                </div>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-2xl font-bold text-foreground-900 font-heading mb-6">
                <a href="#faq">常见问题</a>
              </h2>
              <div className="space-y-3">
                {[
                  { q: '黑料网不打烊是什么？', a: '黑料网不打烊是一个24小时不间断更新的娱乐八卦资讯聚合平台，汇聚娱乐圈、网红圈、明星圈最新劲爆黑料内容，为用户提供全面、及时、独家的黑料资讯。' },
                  { q: '黑料网不打烊的内容多久更新一次？', a: '黑料网不打烊全天候24小时不间断更新，确保用户随时随地都能获取最新的独家黑料内容。我们的编辑团队7×24小时轮班工作，保证内容的时效性和准确性。' },
                  { q: '如何向黑料网不打烊投稿？', a: '您可以通过我们的投稿邮箱 tips@heiliao-budayang.com 提交线索或稿件。我们欢迎各界人士提供真实可靠的爆料信息，所有投稿都会经过编辑团队的严格审核。' },
                  { q: '黑料网不打烊的内容是否可靠？', a: '我们致力于为读者提供真实、可靠的娱乐资讯。所有发布的内容都经过编辑团队的多方核实和严格把关。但由于娱乐资讯的特殊性，部分内容可能涉及未经官方确认的消息，我们会在文章中明确标注信息来源。' },
                ].map((faq, idx) => (
                  <details key={idx} className="group rounded-lg bg-background-100 border border-background-200/60 overflow-hidden">
                    <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                      <span className="text-sm font-medium text-foreground-800">{faq.q}</span>
                      <span className="w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                        <i className="ri-arrow-down-s-line"></i>
                      </span>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>

            <div id="contact">
              <h2 className="text-2xl font-bold text-foreground-900 font-heading mb-6">
                <a href="#contact-form">联系我们</a>
              </h2>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h4>
                      <p className="text-sm text-foreground-500">contact@heiliao-budayang.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-briefcase-line"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-800 mb-1">商务合作</h4>
                      <p className="text-sm text-foreground-500">business@heiliao-budayang.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-chat-new-line"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-800 mb-1">内容投稿</h4>
                      <p className="text-sm text-foreground-500">tips@heiliao-budayang.com</p>
                    </div>
                  </div>
                </div>

                <form onSubmit={handleSubmit} data-readdy-form="" id="about-contact-form" className="space-y-4">
                  {formStatus === 'success' && (
                    <div className="p-4 rounded-lg bg-accent-50 border border-accent-200 text-accent-800 text-sm">
                      感谢您的留言！我们会尽快回复您。
                    </div>
                  )}
                  {formStatus === 'error' && (
                    <div className="p-4 rounded-lg bg-primary-50 border border-primary-200 text-primary-800 text-sm">
                      {formError}
                    </div>
                  )}
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/60 text-sm text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/60 text-sm text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/60 text-sm text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                      placeholder="请输入您的留言内容（500字以内）"
                    ></textarea>
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <button
                    type="submit"
                    disabled={formStatus === 'submitting'}
                    className="w-full py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50"
                  >
                    {formStatus === 'submitting' ? '提交中...' : '提交留言'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}